const navigation = {
    // Main Navigation
    dashboard: 'Dashboard',
    apiProductsAutomations: 'API-Produkte & Automatisierungen',
    customers: 'Kunden',
    customerBilling: 'Kundenabrechnung',
    analytics: 'Analytics',
    documentation: 'Dokumentation',
    customerPreview: 'Kundenvorschau',
    florentinBilling: 'Abrechnung',
    settings: 'Einstellungen',
    helpSupport: 'Hilfe & Support',
    
    // User Menu
    organization: 'ORGANISATION',
    account: 'KONTO',
    agencyOrganization: 'Agentur-Organisation',
    manageMembers: 'Mitglieder verwalten',
    profile: 'Profil',
    billingPlan: 'Abrechnung & Tarif',
    language: 'Sprache',
    supportCenter: 'Support-Center',
    apiDocumentation: 'API-Dokumentation',
    logout: 'Abmelden',
    
    // Plan Info
    growthPlan: 'Wachstumstarif',
    planDetails: '{{price}}/Monat + {{fee}} Gebühren',
    admin: 'ADMIN',
    
    // Provider Info
    providerAccount: 'Provider-Konto',
    billingLabelSuffix: 'Abrechnung',
  } as const;

export default navigation;
